import { render, staticRenderFns } from "./ScalingBar.vue?vue&type=template&id=247fbd0a&scoped=true&lang=pug&"
import script from "./ScalingBar.vue?vue&type=script&lang=js&"
export * from "./ScalingBar.vue?vue&type=script&lang=js&"
import style0 from "./ScalingBar.vue?vue&type=style&index=0&id=247fbd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fbd0a",
  null
  
)

export default component.exports